import React, { useContext, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { SkycityContext } from '../../lib/SkycityProvider'

import { error } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Select from '@react/react-spectrum/Select'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import axios from 'axios'

import { ssApiSyncCall } from '../../lib/ccApi.js'
import {
    getFilename,
    getFilenameWithoutExt,
    getEncodedURI,
    getTempDirectory,
    getSenseiHeaders,
    checkFileType,
    getEndpointByRegion
} from '../../lib/skycity.js'
import {
    exploreIndexDocument,
    exploreHomeDirectory,
    uploadFile,
    retrieveRendition,
    retrievePreSignedDownloadUrl
} from '../../lib/acpApi.js'
const LinkHeader = require('http-link-header')
const uuid = require('uuid/v4')

export default function Operation (files) {
    const {
        inputFiles,
        errorOptions,
        dispatch,
        region,
        localeLabels
    } = useContext(SkycityContext)

    const [localeOptions, setLocales] = useState(localeLabels)

    async function start (curFile) {
        //  replace with presignedUrl
        const filePath = curFile.path
        const codePayload = {
            contentAnalyzerRequests: {
                'sensei:name': 'Entity Segmentation',
                'sensei:invocation_mode': 'synchronous',
                'sensei:invocation_batch': false,
                'sensei:in_response': false,
                'sensei:engines': [
                    {
                        'sensei:execution_info': {
                            'sensei:engine': 'Classification:autocrop:Service-2f460ce236f5462fb90987110618f24c'
                        },
                        'sensei:params': {
                            locale: localeOptions.find(localeOption => localeOption.selected === true).value || 'en_US'
                        },
                        'sensei:inputs': {
                            image: {
                                'dc:format': checkFileType(curFile.type),
                                'sensei:repoType': 'HTTP',
                                'repo:path': filePath
                            }
                        },
                        'sensei:outputs': {
                            semantic_masks: {
                                'dc:format': 'image/png',
                                'sensei:multipart_field_name': 'semantic_masks'
                            },
                            stuff_masks: {
                                'dc:format': 'image/png',
                                'sensei:multipart_field_name': 'stuff_masks'
                            },
                            metadata: {
                                'dc:format': 'application/json',
                                'sensei:multipart_field_name': 'metadata'
                            }
                        }
                    }
                ]
            }
        }

        const formData = new FormData()
        formData.append('contentAnalyzerRequests', JSON.stringify(codePayload.contentAnalyzerRequests))
        const config = {
            file: curFile,
            url: `${getEndpointByRegion(region)}/predict`,
            method: 'POST',
            mode: 'cors',
            timeout: 90000,
            headers: getSenseiHeaders(),
            payload: codePayload,
            body: {
                formData: formData
            }
        }

        /* *********************************** */
        dispatch({ type: 'set-codes', payload: { config: config } })

        const responseBody = await ssApiSyncCall(config)
        const contentAnalyzerResponse = responseBody.get('contentAnalyzerResponse')
        // const response = JSON.parse(responseBody.get('metadata'))
        const senseiMetadata = JSON.parse(contentAnalyzerResponse)
        const masks = senseiMetadata.statuses[0].invocations[0]['sensei:outputs'].semantic_masks
        const stuffMasks = senseiMetadata.statuses[0].invocations[0]['sensei:outputs'].stuff_masks
        // const metadata_out = senseiMetadata.statuses[0].invocations[0]['sensei:outputs'].metadata

        const entities = JSON.parse(responseBody.get('metadata'))

        // 1. Explore the Index Document and get the Primary URL of the home Directory
        const homeDirectoryPrimaryUrl = await exploreIndexDocument()

        // 2. Explore the home Directory and get the Create URL of the Cloud Documents Directory
        const exploreHomeDirectoryResponse = await exploreHomeDirectory(
            homeDirectoryPrimaryUrl
        )
        const cloudDocumentsCreateUrl = exploreHomeDirectoryResponse.createLink
        // upload semantic_masks
        for (let i = 0; i < masks.length; ++i) {
            const output = responseBody.get(masks[i]['sensei:multipart_field_name'])
            const blob = output.slice(0, output.size, 'image/png')
            const outputFileName = `entityseg_mask_${uuid()}_${curFile.shortName}.png`
            const newFile = new File([blob], outputFileName, { type: 'image/png' })
            const outputHref = `${getTempDirectory()}/${outputFileName}`
            const fileUploaded = await uploadFile(
                cloudDocumentsCreateUrl,
                newFile
            )
            const uploadlinks = LinkHeader.parse(fileUploaded.headers.get('link'))
            const primaryUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/primary'))[0].uri
            const renditionUrl = uploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/rendition'))[0].uri
            const preSignedDownloadUrl = await retrievePreSignedDownloadUrl(primaryUrl)
            const largeRendition = await retrieveRendition(
                renditionUrl,
                0,
                'image/jpeg'
            )
            files.push({
                inputFile: curFile,
                name: getFilename(outputHref),
                shortName: getFilenameWithoutExt(outputHref),
                path: outputHref,
                outputThumbnail: largeRendition,
                output: largeRendition,
                outputToDownload: preSignedDownloadUrl
            })
        }
        // upload stuff masks
        for (let i = 0; i < stuffMasks.length; ++i) {
            const output = responseBody.get(stuffMasks[i]['sensei:multipart_field_name'])
            const blob = output.slice(0, output.size, 'image/png')
            const outputFileName = `entityseg_stuff_mask_${uuid()}_${curFile.shortName}.png`
            const newFile = new File([blob], outputFileName, { type: 'image/png' })
            const outputHref = `${getTempDirectory()}/${outputFileName}`
            const stuffFileUploaded = await uploadFile(
                cloudDocumentsCreateUrl,
                newFile
            )
            const stuffUploadlinks = LinkHeader.parse(stuffFileUploaded.headers.get('link'))
            const stuffPrimaryUrl = stuffUploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/primary'))[0].uri
            const stuffRenditionUrl = stuffUploadlinks.refs.filter(val => val.rel.match('http://ns.adobe.com/adobecloud/rel/rendition'))[0].uri
            const stuffPreSignedDownloadUrl = await retrievePreSignedDownloadUrl(stuffPrimaryUrl)
            const stuffLargeRendition = await retrieveRendition(
                stuffRenditionUrl,
                0,
                'image/jpeg'
            )
            files.push({
                inputFile: curFile,
                name: getFilename(outputHref),
                shortName: getFilenameWithoutExt(outputHref),
                path: outputHref,
                outputThumbnail: stuffLargeRendition,
                output: stuffLargeRendition,
                outputToDownload: stuffPreSignedDownloadUrl
            })
        }

        dispatch({
            type: 'skycity-success',
            payload: {
                files: files,
                response: entities,
                loading: false,
                wait: false
            }
        })
    }

    async function run (e) {
        try {
            dispatch({ type: 'skycity-run', payload: {} })

            files = []
            const funcArray = []
            inputFiles.forEach(curFile => {
                funcArray.push(start(curFile))
            })
            await axios.all(funcArray)
        } catch (e) {
            error(`${__('error_msg_title')}: ${e}`, {
                timeout: 0
            })
            errorOccured(`${__('error_msg_title')}: ${e}`)
        }
    }

    function isRunDisabled () {
        if (inputFiles && inputFiles.length > 0) {
            return false
        }
        return true
    }

    function errorOccured (errMsg, res) {
        console.log(errMsg)
        error(errMsg.slice(0, errorOptions.wordSlice), {
            onClose: () => console.log('close'),
            timeout: errorOptions.msgTimeout
        })
        dispatch({ type: 'error-occured', payload: { errMsg: errMsg, response: res, loading: false, wait: false } })
    }

    function changeLocale (e) {
        const newOptions = localeLabels.map(localeOption => {
            if (localeOption && localeOption.value === e) {
                localeOption.selected = true
            } else if (localeOption) {
                localeOption.selected = false
            }
            return localeOption
        })
        setLocales(newOptions)
    }

    try {
        return <div>
            <Well>
                <Heading variant="pageTitle">{__('ssentitysegmentation_options')}</Heading>
                <br />
                <div className="adobe-skycity-no-wrap-options">
                    <FieldLabel label="Label Localization" labelFor="locale-type" position="left">
                        <Select
                            options={localeLabels}
                            id="locale-type"
                            onChange={e => changeLocale(e)}
                            defaultValue={localeLabels.find(locale => locale.selected === true).value} />
                    </FieldLabel>
                </div>
            </Well>
            <div className="adobe-skycity-button-right">
                <Button variant="cta" onClick={e => run(e)} disabled={isRunDisabled()}>{__('btn_run')}</Button>
            </div>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }

    return null
}
